import { c as _c } from "react/compiler-runtime";
import { getOrgAgentsByAgentIdBuilderOptions } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';
import { bundleFromResponse, isRulesNode } from '@/features/agent-builder';

// Returns the single rules node behind a rule-result artifact (matched by nodeId) from the agent
// graph — the artifact carries only condition IDs + outcomes, so the groups/values/expressions must
// come from the graph. Read-only: reuses the wire mapping, no builder store, so it can't mutate the agent.
const useAgentRulesNode = t0 => {
  const $ = _c(12);
  const {
    agentId,
    versionId,
    nodeId
  } = t0;
  let t1;
  if ($[0] !== agentId || $[1] !== versionId) {
    t1 = getOrgAgentsByAgentIdBuilderOptions({
      path: {
        agentId
      },
      query: {
        versionId
      }
    });
    $[0] = agentId;
    $[1] = versionId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = Boolean(agentId && versionId && nodeId);
  let t3;
  if ($[3] !== nodeId) {
    t3 = response => bundleFromResponse(response).nodes.filter(isRulesNode).find(node => node.id === nodeId) ?? null;
    $[3] = nodeId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = {
      ...t1,
      enabled: t2,
      select: t3
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const query = useQuery(t4);
  const t5 = query.data ?? null;
  let t6;
  if ($[9] !== query.isLoading || $[10] !== t5) {
    t6 = {
      node: t5,
      isPending: query.isLoading
    };
    $[9] = query.isLoading;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default useAgentRulesNode;